import { useEffect, useRef } from 'react';

const usePrevious = <T extends any>(value: T): T => {
  const ref = useRef<any>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
